module.exports = __webpack_public_path__ + "img/best-seller.d71567e0.png";